# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://coffeescript.org/

window.generate_tree_select = (selector) ->
  treeObj = $(selector).treeMultiselect({searchable: true, searchParams: ['text', 'section'], showSectionOnSelected: false, startCollapsed: true});
  $(selector).prop("treeFunctions", treeObj[0])

window.set_dview_active = () ->
  $(".dview-inactive-visible").hide()
  $(".dview-active-visible").show()

window.clear_file_field_text = (cfc, clear_btn) ->
  cfc.text("")
  clear_btn.hide()
  cfc.removeClass("no-right-border")
  cfc.addClass("text-secondary")

# TODO: Move this somewhere generic
window.set_file_callbacks = (clear_jquery, input_jquery) ->
  clear_jquery.on("click", (e) ->
    confirmText = $(this).data("confirm") || "Are you sure you want to remove this upload?"
    if confirm(confirmText)
      file_field_id = $(this).parent().parent().attr("id")
      file_field = $("#" + file_field_id + " > div.custom-file" + " > input.form-control")

      if file_field[0].files.length > 0
        file_field.val(null)

      if (file_field.data("has-image") || file_field.data("has-logo")) && $("#remove-" + file_field_id).length == 0
        # Create a hidden input for the "remove_file" parameter and add it to the page.
        clear_field = $("<input>")
        clear_field.attr("type", "hidden")
        clear_field.attr("name", file_field.data("remove-field-name"))
        clear_field.attr("value", "1")
        clear_field.attr("id", "remove-" + file_field_id)
        $("#" + file_field_id).parent().parent().append(clear_field)

      clear_file_field_text($("#" + file_field_id + " > .custom-file" + " > .custom-file-control"), $(this))
  )

  input_jquery.on("change", (e) ->
    file_field_id = $(this).parent().parent().attr("id")
    cfc = $(this).siblings(".custom-file-control")

    if this.files?.length > 0
      cfc.text(this.files[0].name)
      $("#clear-" + file_field_id).show()
      cfc.addClass("no-right-border")
      cfc.removeClass("text-secondary")

      # If we've previously set up to remove an image that already exists, undo that.
      if $("#remove-" + file_field_id).length > 0
        $("#remove-" + file_field_id).remove()
    else
      clear_file_field_text(cfc, $("#clear-" + file_field_id))
  )

$(document).on "turbolinks:load", ->
  $("#dissection-question-topic-multiselect input[type='checkbox']").on("change", (e) ->
    update_multiselect_text("#dissection-question-topic-multiselect")
  )

  # TODO: Put this in a more general spot?
  $('[data-bs-toggle="modal-confirm"][data-confirm][data-bs-target]').on("click", (e) ->
    if confirm($(this).data("confirm"))
      $($(this).data("bs-target")).modal('show')
  )

  set_file_callbacks($(".clear-file-button"), $("input.form-control"))

  # Or test whether the object is visible?
  if $("#hierarchy-load-target option").length > 0
    generate_tree_select("#hierarchy-load-target")
    set_dview_active()

  $(".filter-row.view-selection").on("click", (e) ->
    # Unless clicking on thumbnail, select view.
    $(this).find('input:radio').prop('checked', true)

    # Revert previously selected view to normal styling.
    $(".filter-row.view-selected td:nth-child(3)").addClass("text-muted")
    $(".filter-row.view-selected").removeClass('view-selected')

    # Change background and text color for selected view.
    $(this).addClass('view-selected')
    $(this).find('td:nth-child(3)').removeClass("text-muted")
  )
